import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { ErrorBoundary } from "./observability/ErrorBoundary";
import "./generated/tokens.css"; // jmix-exit E3a.2: --fawkes-* tokens (default docasoft-green on :root)
import "./generated/themes/warm.css"; // theme matrix — activated via data-fawkes-theme
import "./generated/themes/dark.css";
import "./generated/themes/high-contrast.css";
import "@fawkes/ui/styles.css"; // the shared @fawkes/ui component styles (consume the tokens)
import "./styles.css"; // platform SPA chrome (shell + screen-scoped .fawkes-* additions)

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
